import { createStore } from 'vuex'

import { getCustomSolModule } from '@/store/solutions/sol_customSols'
import { namespaces } from '@/helpers/constants'
import api from './api/api'
import auth from './auth/auth'
import userSettings from './userSettings/userSettings'
import messages from './messages/messages'
import globals from './globals/globals'
import hotkeys from './hotkeys/hotkeys'
import { getRouterModule } from './router/index'
import gameformat from './gameformat/index'
import { getGmfSelektorModule } from './gameformat/gmf_selektor'
import { getGamestateModule } from './gamestate/index'
import switchers from './switchers/index'
import getBroadcastModule from './broadcast/index'
import { getAnimModule } from './animations/animations'
import { getSoundsModule } from './sounds/sounds'

import { getSolfigrModule } from './solfigr/solfigr'
import { getRepfigrModule } from './reports/repfigr'

import poker from './poker/poker'
import { getSolutionsModule } from './solutions/index'
import reports from './reports/index'
import tableFilters from './tableFilters/index'
import savedFilters from './tableFilters/savedFilters'

import { getTrainerModule } from './trainer/trainer' // hand
import hands from './trainer/hands'
import drills from './trainer/drills'
import tags from './tags/tags'
import stats from './trainer/stats'
import session from './trainer/session'
import panels from './trainer/panels'
import history from './trainer/history'
import streak from './trainer/streak'
import hints from './trainer/hints'
import { connectXstateStore } from './connect-xstate-store'

const bc_channels = {
  app: null,
}

const store = createStore({
  modules: {
    auth,
    userSettings,
    api,
    messages,
    globals,
    hotkeys,
    switchers,
    tags,
    tableFilters,
    savedFilters,
    gameformat,
    poker,

    router: getRouterModule(null),
    gamestate: getGamestateModule(null),
    gmf_selektor: getGmfSelektorModule(null),
    sol_custom: getCustomSolModule(null),

    animations: getAnimModule(null),
    broadcast: getBroadcastModule(bc_channels),

    solutions: getSolutionsModule(null),
    reports,
    solfigr_form: getSolfigrModule(null),

    [namespaces.STUDY]: {
      namespaced: true,
      modules: {
        router: getRouterModule(namespaces.STUDY),
        gamestate: getGamestateModule(namespaces.STUDY),
        gmf_selektor: getGmfSelektorModule(namespaces.STUDY),
        sol_custom: getCustomSolModule(namespaces.STUDY),
        solfigr_form: getSolfigrModule(namespaces.STUDY),
      },
    },
    [namespaces.REPORTS]: {
      namespaced: true,
      modules: {
        router: getRouterModule(namespaces.REPORTS),
        gamestate: getGamestateModule(namespaces.REPORTS),
        gmf_selektor: getGmfSelektorModule(namespaces.REPORTS),
        sol_custom: getCustomSolModule(namespaces.REPORTS),
        solfigr_form: getSolfigrModule(namespaces.REPORTS),
        repfigr_form: getRepfigrModule(namespaces.REPORTS),
      },
    },

    // TRAINER
    hands, // top control for multitableer
    drills,
    stats,
    session,
    panels,
    history,
    streak,
    hints,
    sounds: getSoundsModule(null),
    tra: {
      namespaced: true,
      modules: {
        alpha: {
          namespaced: true,
          modules: {
            router: getRouterModule('tra/alpha'),
            trainer: getTrainerModule('tra/alpha'),
            gamestate: getGamestateModule('tra/alpha'),
            animations: getAnimModule('tra/alpha'),
            gmf_selektor: getGmfSelektorModule('tra/alpha'),
            solfigr_form: getSolfigrModule('tra/alpha'),
            sol_custom: getCustomSolModule('tra/alpha'),
          },
        },
        beta: {
          namespaced: true,
          modules: {
            router: getRouterModule('tra/beta'),
            trainer: getTrainerModule('tra/beta'),
            gamestate: getGamestateModule('tra/beta'),
            animations: getAnimModule('tra/beta'),
            gmf_selektor: getGmfSelektorModule('tra/beta'),
            sol_custom: getCustomSolModule('tra/beta'),
          },
        },
        gamma: {
          namespaced: true,
          modules: {
            router: getRouterModule('tra/gamma'),
            trainer: getTrainerModule('tra/gamma'),
            gamestate: getGamestateModule('tra/gamma'),
            animations: getAnimModule('tra/gamma'),
            gmf_selektor: getGmfSelektorModule('tra/gamma'),
            sol_custom: getCustomSolModule('tra/gamma'),
          },
        },
        delta: {
          namespaced: true,
          modules: {
            router: getRouterModule('tra/delta'),
            trainer: getTrainerModule('tra/delta'),
            gamestate: getGamestateModule('tra/delta'),
            animations: getAnimModule('tra/delta'),
            gmf_selektor: getGmfSelektorModule('tra/delta'),
            sol_custom: getCustomSolModule('tra/delta'),
          },
        },
        replay: {
          namespaced: true,
          modules: {
            router: getRouterModule('tra/replay'),
            trainer: getTrainerModule('tra/replay'),
            gamestate: getGamestateModule('tra/replay'),
            animations: getAnimModule('tra/replay'),
            gmf_selektor: getGmfSelektorModule('tra/replay'),
            sol_custom: getCustomSolModule('tra/replay'),
          },
        },
      },
    },

    tmp: {
      namespaced: true,
      modules: {
        primary: {
          namespaced: true,
          modules: {
            solutions: getSolutionsModule('tmp/primary'),
            router: getRouterModule('tmp/primary'),
            gamestate: getGamestateModule('tmp/primary'),
            gmf_selektor: getGmfSelektorModule('tmp/primary'),
            animations: getAnimModule('tra/primary'),
            solfigr_form: getSolfigrModule('tmp/primary'),
            sol_custom: getCustomSolModule('tmp/primary'),
          },
        },
        secondary: {
          namespaced: true,
          modules: {
            router: getRouterModule('tmp/secondary'),
            gamestate: getGamestateModule('tmp/secondary'),
            gmf_selektor: getGmfSelektorModule('tmp/secondary'),
            animations: getAnimModule('tra/secondary'),
            solfigr_form: getSolfigrModule('tmp/secondary'),
            sol_custom: getCustomSolModule('tmp/secondary'),
          },
        },
        extra1: {
          namespaced: true,
          modules: {
            router: getRouterModule('tmp/extra1'),
            gamestate: getGamestateModule('tmp/extra1'),
            gmf_selektor: getGmfSelektorModule('tmp/extra1'),
            animations: getAnimModule('tra/extra1'),
            solfigr_form: getSolfigrModule('tmp/extra1'),
            sol_custom: getCustomSolModule('tmp/extra1'),
          },
        },
        extra2: {
          namespaced: true,
          modules: {
            router: getRouterModule('tmp/extra2'),
            gamestate: getGamestateModule('tmp/extra2'),
            gmf_selektor: getGmfSelektorModule('tmp/extra2'),
            animations: getAnimModule('tra/extra2'),
            solfigr_form: getSolfigrModule('tmp/extra2'),
            sol_custom: getCustomSolModule('tmp/extra2'),
          },
        },
        extra3: {
          namespaced: true,
          modules: {
            router: getRouterModule('tmp/extra3'),
            gamestate: getGamestateModule('tmp/extra3'),
            gmf_selektor: getGmfSelektorModule('tmp/extra3'),
            animations: getAnimModule('tra/extra3'),
            solfigr_form: getSolfigrModule('tmp/extra3'),
            sol_custom: getCustomSolModule('tmp/extra3'),
            trainer: getTrainerModule('tra/extra3'),
          },
        },
      },
    },
  },
})

function bc_handleMessage(message) {
  store.dispatch('bc_handleMessage', message)
}
function bc_handleError(message) {
  store.dispatch('bc_handleMessageError', message)
}
if ('BroadcastChannel' in window) {
  bc_channels.app = new BroadcastChannel('bc_app')
  bc_channels.app.onmessage = bc_handleMessage
  bc_channels.app.onmessageerror = bc_handleError
}

if (window.Cypress) {
  window.cy_store = store
}

// store.subscribe(({ type, payload }, state) => {
//   console.log(`%c 🧟‍♀️ Mutation:   ${type} `, 'color: #bada55', {
//     payload,
//     state,
//   })
// })

// store.subscribeAction(({ type, payload }, state) => {
//   console.log(`%c 🎬 Action:     ${type} `, 'color: #54afbd', {
//     payload,
//     state,
//   })
// })

connectXstateStore(store)

export default store
